import React, { FunctionComponent, useEffect, useState } from 'react';
import "./layout.scss"

import Header from '../../components/header/headerContainer';
import { ILayoutProps } from '../../constants/commonTypes'
import { useLocation } from 'react-router';
import { useDispatch, useStore } from 'react-redux';
import { resetInAppBackPressed } from '../../core/actionCreators/configActionCreator';
import { forcedLogoutUser, getStorage, getTransactionIdFromURL } from '../../constants/utils';
import Loader from '../../components/loader/loader';
import { APPLICATION_LOADED } from '../../constants/constants';
import { BROWSER_BACK_ALERT } from '../../constants/messages';


const Layout: FunctionComponent<ILayoutProps> = (props) => {
  const { children, isAuthenticated, partnerName } = props;
  let txnId = getTransactionIdFromURL();
  const { pathname } = useLocation();
  const [renderChildren, setRenderChildren] = useState(true)

  const RestrictNavigation = () => {
    const store = useStore()
    const dispatch = useDispatch()
    const browserBackHandler = () => {
      if (store.getState().config.inAppBackPressed) {
        dispatch(resetInAppBackPressed())
        return true
      }
      alert(BROWSER_BACK_ALERT)
      forcedLogoutUser()
      setRenderChildren(false)
      return false
    }
    useEffect(() => {
      window.onpopstate = browserBackHandler
    })

    useEffect(() => {
      if (!!process.env.REACT_APP_RESTRICT_NAVIGATION) {
        return
      }
      window.onbeforeunload = function restrictRefresh(event: any) {
        const applicationAlreadyLoaded = getStorage(APPLICATION_LOADED)
        if (isAuthenticated && applicationAlreadyLoaded) {
          setRenderChildren(false)
          forcedLogoutUser()
          event.preventDefault();
          event.returnValue = false;
          return
        }
      }
    }, [])
    return null;
  }


  // Scroll to top after every component render
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // useEffect(() => {
  //   if(partnerName && partnerName !== ""){
  //     pushDataLayer(COMMON_GA(txnId, partnerName))
  //   }
  // }, [txnId, partnerName])

  return (
    <div className={!isAuthenticated ? "layout-wrapper-footer" : "layout-wrapper-header"}>
      <Header />
      <RestrictNavigation />
      {renderChildren ? children : <Loader />}
    </div>
  )
}



export default Layout;
